<template>
  <div>
    <a-card v-if="viewstatementList" :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="24">
            <a-col :md="6" :sm="24">
              <a-form-item label="账单号"  style="margin-left: 39px">
                <a-input v-model.trim="queryParam.statementNo"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="账单状态" style="margin-left: 26px" >
                <a-select  v-model="queryParam.statementStatus" :allowClear="true">
                  <a-select-option  v-for="type in statement_status" :title="type.dictLabel":key="type.dictValue">{{type.dictLabel}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="订单号"style="margin-left: 45px">
                <a-input v-model.trim="queryParam.orderNo"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="结算状态"  style="margin-left: 30px">
                <a-select  v-model="queryParam.settleStatus" :allowClear="true">
                  <a-select-option  v-for="type in settlement_status" :title="type.dictLabel":key="type.dictValue">{{type.dictLabel}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :md="6" :sm="24">
              <a-form-item label="开票状态"  style="margin-left: 26px">
                <a-select  v-model="queryParam.invoiceStatus" :allowClear="true">
                  <a-select-option  v-for="type in invoice_status" :title="type.dictLabel":key="type.dictValue">{{type.dictLabel}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="订单总计" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 26px">
                <a-col :span="11">
                  <a-input placeholder="最小值" v-model.trim="queryParam.orderTotalNumBegin"/>
                </a-col>
                <a-col :span="2" style="display: flex;justify-content: center">
                  -
                </a-col>
                <a-col :span="11">
                  <a-input placeholder="最大值" v-model.trim="queryParam.orderTotalNumEnd"/>
                </a-col>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item  label="客户姓名"  style="margin-left: 30px">
                <a-input v-model.trim="queryParam.customerMobile"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item  label="客户联系方式" >
                <a-input v-model.trim="queryParam.customerName"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :md="12" :sm="24">
              <a-row :gutter="24" style="margin-left: 0px">
                <a-form-item  label="客户地址" style="margin-left: 26px">
                  <a-col :md="5" :sm="24">
                    <a-select  v-model="queryParam.provinceId"
                              @change="getselect" :allowClear="true">
                      <a-select-option  v-for="type in selectAllProvince":title="type.provinceName" :key="type.provinceCode">{{type.provinceName}}</a-select-option>
                    </a-select>
                  </a-col>
                  <a-col :md="5" :sm="24">
                    <a-select  v-model="queryParam.cityId"
                              @change="getprovinceName" :allowClear="true">
                      <a-select-option  v-for="type in selectCityName":title="type.cityName"  :key="type.cityCode">{{type.cityName}}</a-select-option>
                    </a-select >
                  </a-col>
                  <a-col :md="5" :sm="24">
                    <a-select  v-model="queryParam.areaId"  :allowClear="true">
                      <a-select-option  v-for="type in selectAreaName" :title="type.areaName":key="type.areaCode">{{type.areaName}}</a-select-option>
                    </a-select>
                  </a-col>
                  <a-col :md="9" :sm="24">
                    <a-input  v-model.trim="queryParam.customerAddr"/>
                  </a-col>
                </a-form-item>
              </a-row>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="建单时间"  style="margin-left: 30px">
                <a-range-picker format="YYYY-MM-DD HH:mm:ss"style="width: 100%" v-model="createOrder" :show-time="{ hideDisabledOptions: true, defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')], }"@change="onChange_e"  />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="结算时间"  style="margin-left: 30px">
                <a-range-picker format="YYYY-MM-DD HH:mm:ss" style="width: 100%" v-model="settleTime" :show-time="{ hideDisabledOptions: true, defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')], }"  @change="onChange_b" />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">

            <a-col :md="6" :sm="24">
              <a-form-item label="订单完成时间" >
                <a-range-picker format="YYYY-MM-DD HH:mm:ss" style="width: 100%" v-model="completeOrder" :show-time="{ hideDisabledOptions: true, defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')], }"@change="onChange_f"  />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="生成对账单时间" >
                <a-range-picker format="YYYY-MM-DD HH:mm:ss" style="width: 100%" v-model="createStatement" :show-time="{ hideDisabledOptions: true, defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')], }" @change="onChange_d"  />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="账单截止日期" >
                <a-range-picker format="YYYY-MM-DD HH:mm:ss"style="width: 100%" v-model="closingDate" :show-time="{ hideDisabledOptions: true, defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')], }" @change="onChange_a"  />
              </a-form-item>
            </a-col>
          </a-row>
          <!--查询 清空-->
          <span class="table-page-search-submitButtons">
          <a-row type="flex" justify="space-between">
            <a-col :span="18"></a-col>
            <a-col :span="6" :style="{ textAlign: 'right' }">
              <a-button type="primary"  htmlType="submit"@click="query">查询</a-button>
              <a-button style="margin-left: 8px" @click="empty">清空</a-button>
          <a-button style="margin-left: 8px" v-if='exportStatementsEnterpriseStatement'type="primary"
                    @click="exportEnt() ">导出 Excel</a-button>
            </a-col>

          </a-row>
        </span>
        </a-form>
      </div>
      <!--    表格内容-->
      <a-table
        size="default"
        ref="table"
        rowKey="sourceId"
        :columns="columns"
        :dataSource="this.subList.rows"
        :pagination="false"
        bordered
        :scroll="{ x: 1600}"
      >

      <span slot="action" slot-scope="text, record" style="white-space: nowrap;">
         <a v-if="checkstatementList"  @click="reconciliation(record)"> 对账</a>
      </span>
      </a-table>

      <a-pagination showQuickJumper="true" showSizeChanger
                    :pageSizeOptions="pageSizeOptions"
                    :pageSize.sync="pageSize"
                    @showSizeChange="onShowSizeChange"
                    :total="total"
                    v-model="current"
                    @change="getdataList1"
                    :showTotal="total => `总共 ${total} 条`"
                    style="text-align: end;margin-top: 20px"
      />

      <!--    最后字段-->
      <a-row  style="margin-top: 20PX" v-if="subList.statistics">
        <a-col :span="19" style="margin: 10px 0">
          <a-row>
            <a-col :span="5" >
            </a-col>
            <a-col :span="19"style="text-align: center" >
            <span
              style="font-size: 14px;font-weight: 700 ;text-align: center">结算金额：{{subList.statistics.enterpriseSettleAmount}}元       已结算金额：{{subList.statistics.alreadySettleAmount}}元
              实际需结算：{{subList.statistics.needSettleAmount}}元    已退款金额：{{subList.statistics.alreadyRefundAmount}}元    订单总计：{{subList.statistics.orderNum}}单</span>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
      <!-- 使用弹框组件-->

      <enterprise-reconciliation-model
        ref="enterpriseReconciliation" @ok="query"></enterprise-reconciliation-model>
    </a-card>
    <no-authority v-else></no-authority>
  </div>

</template>
<script>
  import NoAuthority from '../enterprise/NoAuthority'
  import {ACCESS_TOKEN} from '@/store/mutation-types'
  import moment from 'moment';
  import { STable } from '@/components'
  import { getSubList,getSubStatementDetailList,getexportList } from '@/api/finance/statementList'

  import enterpriseReconciliationModel from './modules/enterpriseReconciliationModel.vue'
  import { checkPermission } from '@/utils/permissions'
  import {getDictMap} from "../../utils/dict"
  import
  {getList,getselectAllProvince,getselectCityName,getselectAreaName,getmarketPrincipal,getSelectBrand,getOrderDetail,getSelectModel,getfindByDeptId,getfinddictAll} from
      '@/api/order/orderList'
  export default {
    name: 'statementList',
    components: {
      STable,
      // 注册弹框组件

      enterpriseReconciliationModel,
      NoAuthority
    },
    data () {
      return {

        // 分页
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        total:0,
        current:1,
        pageSize:10,

        headers: {
          token: Vue.ls.get(ACCESS_TOKEN)
        },
        // 省
        selectAllProvince:[],
        // 市
        selectCityName:[],
        // 区
        selectAreaName:[],
        statement_status: [],
        subList:'',
        // 根据单个id获取到的数据
        Settlementlist:[],
        selectedRowKeys: [], // Check here to configure the default column
        selectedRow:[],
        disabled:true,
        loading: false,
        form: this.$form.createForm(this),
        // 查询参数
        queryParam: {},
        // 表头
        columns: [
          {
            title: '序号',
            dataIndex: 'rowNum',
            align:'center'
          },
          {
            title: '操作栏',

            dataIndex: 'action',
            scopedSlots: { customRender: 'action' },

          },
          {
            title: '账单状态',
            dataIndex: 'statementStatus',
            align:'center'
          } ,  {
            title: '企业名称',
            dataIndex: 'enterpriseName',
            align:'center'
          },
          {
            title: '账单号',
            dataIndex: 'statementNo',
            align:'center'
          },{
            title: '账单截止日期',
            dataIndex: 'closingDate',
            align:'center'
          },{
            title: '结算状态',
            dataIndex: 'settleStatus',
            align:'center'
          }, {
            title: '结算时间',
            dataIndex: 'settleTime',
            align:'center'
          }, {
            title: '订单总计',
            dataIndex: 'orderNum',
            align:'center'
          },{
            title: '安装数量',
            dataIndex: 'installNum',
            align:'center'
          },
          // {
          //   title: '帐单数',
          //   dataIndex: 'subStatementNum',
          //   align:'center'
          // },
          {
            title: '企业订单总金额',
            dataIndex: 'enterpriseTotalAmount',
            align:'center'
          },
          {
            title: '企业结算总金额',
            dataIndex: 'enterpriseSettleAmount',
            align:'center'
          }, {
            title: '已退款金额',
            dataIndex: 'alreadyRefundAmount',
            align:'center'
          }, {
            title: '开票状态',
            dataIndex: 'invoiceStatus',
            align:'center'
          },{
            title: '生成对账单时间',
            dataIndex: 'createStatementTime',
            align:'center'
          },
        ],
        // 字典为结算状态
        settlement_status:[],
        createOrder:'',
        settleTime:'',
        completeOrder:'',
        createStatement:'',
        closingDate:'',
        // 字典为开票状态
        invoice_status:[],
        exportStatementsEnterpriseStatement: checkPermission('exportStatementsEnterpriseStatement'),
        checkstatementList: checkPermission('checkstatementList'),
        viewstatementList: checkPermission('viewstatementList'),

      }
    },
    filters: {
    },
    // 下拉框的选项
    async created () {
      await  getselectAllProvince().then(res=>{
        if(res.code===0){
          // console.log(res)
          this.selectAllProvince= res.rows
        } else {
          this.$message.error(res.msg);
        }
      })
      let dictTypes=['invoice_status','statement_status','settlement_status']
      getfinddictAll({dictTypes:dictTypes.join()}).then(res => {
        this.statement_status=res.statement_status
        this.settlement_status=res.settlement_status
        this.invoice_status=res.invoice_status
      })

      this.getdataList1(1)

    },
    methods: {

      // 分页
      onShowSizeChange(current, pageSize) {
        this.pageSize = pageSize;
        this.getdataList1(current)
      },

      getdataList1(value){
        this.queryParam.pageNum = value
        this.queryParam.pageSize = this.pageSize
        this.handloadData()
      },
      handloadData() {
        getSubList(this.queryParam).then(res => {
          console.log(res)
          this.subList = res
          this.total = res.total
        })
      },

      SetOptionTitle(){
        var selects = document.getElementsByTagName("select");
        if (selects.length > 0) {
          for (var i = 0; i < selects.length; i++) {
            var options = selects[i].options;
            if (selects[i].options.length > 0) {
              for (var j = 0; j < options.length; j++) {
                if (options[j].title == "")
                  options[j].title = options[j].text;
              }
            }
          }
        }
      },
      moment,
      empty(){
        // this.queryParam={}

        this.queryParam.statementNo =''
        this.queryParam.statementStatus =''
        this.queryParam.orderNo =''
        this.queryParam.settleStatus =''
        this.queryParam.invoiceStatus =''
        this.queryParam.orderTotalNumBegin =''
        this.queryParam.orderTotalNumEnd =''
        this.queryParam.customerMobile =''
        this.queryParam.customerName =''
        this.queryParam.provinceId =''
        this.queryParam.cityId =''
        this.queryParam.areaId =''
        this.queryParam.customerAddr =''

        this.createOrder=''
        this.settleTime=''
        this.completeOrder=''
        this.createStatement=''
        this.closingDate=''

      },
      exportEnt () {
        var str=process.env.VUE_APP_API_BASE_URL + '/finance/enterpriseStatement/subExport?pageNum=1&pageSize=10'
        for(let i in this.queryParam ){
          if(this.queryParam[i]!=undefined){
            str=str+'&'+i+'='+this.queryParam[i]
          }
        }
        str=str+'&token='+this.headers.token
        window.open(str)

      },
      query(){
        getSubList(this.queryParam).then(res=>{
          if (res.code===0){
            this.subList=res
          }else {
            this.$message.error(res.msg);
          }
        })
      },
      // 市
      getselect(e){
        getselectCityName({provinceCode :e}).then(res=>{
          if(res.code===0){
            console.log(res)
            this.selectCityName= res.rows;
          } else {
            this.$message.error(res.msg);
          }
        })
      },
      // 区
      getprovinceName(e){
        getselectAreaName({cityCode:e}).then(res=>{
          if(res.code===0){
            console.log(res)
            this.selectAreaName= res.rows;
          } else {
            this.$message.error(res.msg);
          }
        })
      },
      // 账单截止日期
      onChange_a(date, dateString) {
        this.queryParam.closingDateBegin=dateString[0]
        this.queryParam.closingDateEnd=dateString[1]
      },
      // 结算时间
      onChange_b(date, dateString) {
        this.queryParam.settleTimeBegin=dateString[0]
        this.queryParam.settleTimeEnd=dateString[1]
      },
      onChange_d(date, dateString) {
        this.queryParam.createStatementTimeBegin=dateString[0]
        this.queryParam.createStatementTimeEnd=dateString[1]
      },
      onChange_e(date, dateString) {
        this.queryParam.createOrderTimeBegin=dateString[0]
        this.queryParam.createOrderTimeEnd=dateString[1]
      },
      onChange_f(date, dateString) {
        this.queryParam.completeOrderTimeBegin=dateString[0]
        this.queryParam.completeOrderTimeEnd=dateString[1]
      },
      handleChangeMin(e){
        this.queryParam.orderTotalNumBegin=e.target.value
      },
      handleChangeMax(e){
        this.queryParam. orderTotalNumEnd=e.target.value
      },
      // 对账
      reconciliation(record){
        this.$refs.enterpriseReconciliation.showenterpriseReconciliation(record.statementId)
      },



    },
    watch: {
    }
  }
</script>
<style scoped>
  /deep/ .ant-table th { white-space: nowrap; }
  /deep/ .ant-table td {  white-space: nowrap;padding: 4px 16px;}
</style>